import { useMutation, useQuery } from "@tanstack/react-query";
import { client } from "./client";

export const useCreatePlan = ({ onSuccess, onError } = {}) => {
    return useMutation({
        mutationFn: async (payload) => {
            const response = await client("plans", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                data: payload,
            });
            return response; 
        },
        onSuccess,
        onError,
    });
};

export const useGetAllPlans = () => {
    const token = localStorage.getItem("accessToken");
    return useQuery({
        queryKey: ["allPlans"],
        queryFn: async () => {
            const response = await client("plans", {
                method: "GET",
                headers: {
                    Authorization: token ? `Bearer ${token}` : undefined,
                },
            });
            return response;
        },
    });
};

export const useGetActivePlans = () => {
    const token = localStorage.getItem("accessToken");
    return useQuery({
        queryKey: ["activePlans"],
        queryFn: async () => {
            const response = await client("plans/active", {
                method: "GET",
                headers: {
                    Authorization: token ? `Bearer ${token}` : undefined,
                },
            });
            return response;
        },
    });
};

export const useDeletePlanById = (id) => {
    const token = localStorage.getItem("accessToken");
    const { refetch } = useGetAllPlans();

    return useMutation({
        mutationFn: async () => {
            const response = await client(`plans/${id}`, {
                method: "DELETE",
                headers: {
                    Authorization: token ? `Bearer ${token}` : undefined,
                },
            });
            return response;
        },
        onSuccess: () => {
            refetch();
        },
    });
};